let globalSetModal = null;

export const registerSetModal = (setModalFn) => {
  globalSetModal = setModalFn;
};

export const showAlert = (title, message, onButtonClick = null, options = {}) => {
  if (!globalSetModal) {
    return;
  }

  globalSetModal({
    title,
    message,
    show: true,
    onButtonClick: onButtonClick || (() => {}),
    showCancelButton: options.showCancelButton || false,
    buttonText: options.buttonText || "Okay",
  });
};
